<template>
  <div style="min-height:500px;">
    <div class="box">
      <div style="width:48%;text-align:right;">
        <img style="width:350px;" src="../assets/404.svg" />
      </div>
      <div style="position:absolute;top:30px;left:51%;">
        <h2 style="color:#e58f55;">哎呀，您的网络遇到了一点点小问题！</h2>
        <p style="color:#595f65;">显示此网页时出现了错误可能展示暂时连接。</p>
        <div style="position:relative;">
          <div class="circle"></div>
          <span style="margin-left:15px;">
            你可以尝试
            <el-button @click="onrefresh" style="font-size: 16px;" type="text">
              <span style="text-decoration: underline !important;">重新载入</span>
            </el-button>此页面
          </span>
        </div>
        <div style="position:relative;">
          <div class="circle"></div>
          <span style="margin-left:15px;">
            去
            <el-button @click="returnback" style="font-size: 16px;" type="text">
              <span style="text-decoration: underline !important;">捷禾ERP首页</span></el-button>看看吧
          </span>
        </div>
        <el-row style="margin-top:20px;">
          <el-col :span="20">
            <el-button type="primary" @click="returnback">
              <i style="padding-right:15px;" class="el-icon-back"></i>返回首页
            </el-button>
          </el-col>
        </el-row>
        <el-row style="margin-top:10px;">
          <el-col :span="20">
            <el-button type="primary" plain @click="back">
              <i style="padding-right:3px;" class="el-icon-back"></i>返回上一页
            </el-button>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'fails404',
  data () {
    return {

    }
  },

  methods: {
    returnback () {
      this.$router.push({ path: '/' })
    },
    onrefresh () {
      location.reload()
    },
    back () {
      this.$router.go(-1)// 返回上一层
    }
  }
}
</script>
<style scoped>
.circle {
  position: absolute;
  top: 8px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #dbdbdb;
}
.el-col {
  border: 1px solid transparent;
}
li {
  list-style: none;
}
.box {
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translateY(-50%);
}
.el-button--mini,
.el-button--small {
  font-size: 14px;
  border-radius: 3px;
}
</style>
